import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("../views/Dashboard.vue"),
  },
  {
    path: "/report",
    name: "report",
    component: () => import("../views/Report.vue"),
  },
  {
    path: "/change_status",
    name: "change_status",
    component: () => import("../views/ChangeStatus.vue"),
  },
  {
    path: "/create-tracking",
    name: "create-tracking",
    component: () => import("../views/CreateTracking.vue"),
  },
  {
    path: "/tracking",
    name: "tracking",
    component: () => import("../views/Auth.vue"),
  },
  {
    path: "/",
    name: "slash",
    component: () => import("../views/Auth.vue"),
  },
  {
    path: "/report_user",
    name: "report_user",
    component: () => import("../views/ReportUser.vue"),
  },
  {
    path: "/report_excel",
    name: "report_excel",
    component: () => import("../views/ReportExcel.vue"),
  },
  {
    path: "/report_excel_datediff",
    name: "report_excel_datediff",
    component: () => import("../views/ReportDateDiff.vue"),
  },
  {
    path: "/report_excel_datediff_process0",
    name: "report_excel_datediff_process0",
    component: () => import("../views/ReportDateDiffProcess0.vue"),
  },

  {
    path: "/authen",
    name: "authen",
    component: () => import("../views/Authentication.vue"),
  },
  {
    path: "/auth",
    name: "auth",
    component: () => import("../views/Auth.vue"),
  },
  {
    path: "/change_password",
    name: "change_password",
    component: () => import("../views/ChangePassword.vue"),
  },
  {
    path: "/user",
    name: "user",
    component: () => import("../views/User.vue"),
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/Logout.vue"),
  },
  {
    path: "/tracking_detail/:id",
    name: "tracking_detail",
    component: () => import("../views/TrackingDetail.vue"),
  },
  {
    path: "/kbs_detail/:id",
    name: "kbs_detail",
    component: () => import("../views/KBSDetail.vue"),
  },
  {
    path: "/user_tracking_detail/:id",
    name: "user_tracking_detail",
    component: () => import("../views/UserTrackingDetail.vue"),
  },
  {
    path: "/kbs",
    name: "kbs",
    component: () => import("../views/KBS.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: window.location.host == "localhost:8080" ? "/etracking/" : "/",
  routes,
});

export default router;
